import {Box, Grid, InputLabel} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Theme} from "@mui/system";

export const SelectInputLabel = styled(InputLabel)(() => ({
  fontWeight: 400,
  fontFamily: 'Inter',
}));

export const SelectInputRoot = styled(Grid)(({
  display: 'flex',
  alignItems: 'center',
}));

export const SelectInputFullWidth = styled(Grid)(({
  flex: 1
}));

export const SelectInputActionContainer = styled(Box)(({theme}: {theme: Theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.main,
  width: '1.7em',
  height: '1.7em',
  borderRadius: '50%',
  marginTop: '0.5em',
  marginLeft: '0.5em',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  }
}));
